import { BACKEND_APIS } from '@constants'
import { useSignal } from '@preact/signals-react'
import { getSubmit } from '@ui-seeker/utils'
import { useCallback, useEffect } from 'react'
import { useToast } from '../../../../@hooks'
import { groupedExportsModalId } from '../@signals'

export default function useGroupedExportsModal() {
	const data = useSignal({})
	const isLoading = useSignal(false)
	const { showToast } = useToast()
	const isExtra = window.location.pathname.includes('extra')


	const getData = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.REPORT}/export-group-reports`, {
			id: groupedExportsModalId.value,
			executionType: isExtra ? 'execution-extras' : 'execution',
		})
			.then(res => {
				data.value = res
				isLoading.value = false
			})
			.catch(() => {
				showToast.error('Server Error: Could not load exported data.')
				isLoading.value = false
			})
	}, [isExtra])


	useEffect(() => {
		if (groupedExportsModalId.value) getData()
	}, [groupedExportsModalId.value])


	return {
		data: data.value,
		isLoading: isLoading.value,
	}
}